/**
 * Remove unnecessary spaces and normalizes double-byte spaces to single
 * @param fullName
 */
const removeRedundantSpacesFromName = (fullName: string) => {
  return fullName
    .split(new RegExp(/\s/))
    .filter((i) => i !== '')
    .join(' ');
};

/**
 * Remove both hankaku( ) and zenkaku(　) spaces.
 * @param name
 */
const removeHankakuZenkakuSpaces = (str: string) => {
  return str.replace(/[\x20\u3000]/g, '');
};

/**
 * Remove hyphen, period, quote characters
 * @param name
 */
const normalizeName = (name: string) => {
  return removeHankakuZenkakuSpaces(name.replace(/[‘’'.\-—]/g, ''));
};

/**
 * Get the last and first name,
 * Please note that this assumes that the user's last and first names are single words.
 * @param name
 */
const getSeiMei = (name: string) => {
  const [sei, ...mei] = removeRedundantSpacesFromName(name).split(' ');

  return [sei, mei.join(' ')];
};

export {
  removeRedundantSpacesFromName,
  removeHankakuZenkakuSpaces,
  normalizeName,
  getSeiMei, // eslint-disable-line comma-dangle
};
